import { FallbackImage } from '@/app/components/atoms/FallbackImage'

import styles from './Poster.module.scss'
import { POSTER_DEFAULT_COLOR, POSTER_DEFAULT_SIZES } from './constants'
import type { PosterProps } from './types'

/**
 * Poster — imagen con fondo de color y ratio gobernado por el contenedor.
 *
 * Componente presentacional (Server Component). Renderiza una imagen que llena
 * su contenedor (`object-fit: cover`) sobre un fondo de color que actúa como
 * placeholder mientras carga y queda visible si la imagen falla — el fallo de
 * carga real (404, red, CORS...) lo detecta `FallbackImage`, un átomo cliente
 * hoja que oculta la imagen rota sin obligar a `Poster` a hidratar JS.
 *
 * El ratio/tamaño lo define el contenedor (p. ej. la card que lo usa).
 */
export function Poster({
  src,
  alt = '',
  color = POSTER_DEFAULT_COLOR,
  sizes = POSTER_DEFAULT_SIZES,
  priority = false,
  style,
  className,
}: PosterProps) {
  const posterClassName = className ? `${styles.poster} ${className}` : styles.poster

  return (
    <div className={posterClassName} style={{ background: color, ...style }}>
      <FallbackImage
        src={src}
        alt={alt}
        sizes={sizes}
        priority={priority}
        className={styles.image}
      />
    </div>
  )
}
